import numbro from 'numbro'
import semver from 'semver'

import type { Screenshot } from '../api/core'
import type { FeatureGame } from '../features/game/types/Game'
import { getCombinedScreenshots } from '../features/implementation-examples/util/screenshotHelpers'
import type { FormatOptions } from '../types/FormatOptions'

export type ChartColorList = {
  r: number
  g: number
  b: number
}

export const OnePixelBlueImageBase64 =
  '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'

const LANGUAGE_CODE = 'en-US'

class UtilsService {
  getEnvironmentType() {
    const env = process.env.REACT_APP_ENVIRONMENT
    switch (env) {
      case 'dev':
      case 'local-dev':
        return 'dev'

      case 'stage':
        return 'stage'

      case 'local-dev-qa':
      case 'qa':
        return 'qa'

      case 'local-dev-prod':
      case 'prod':
        return 'prod'

      default:
        return undefined
    }
  }

  getRandomPassword() {
    const lowerCaseCharacters = 'abcdefghijklmnopqrstuvwxyz'
    const upperCaseCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
    const numberCharacters = '0123456789'
    const specialCharacters = '!@#$&*%'

    const passwordArray = []

    for (let i = 0; i < this.random(4, 6); i++) {
      passwordArray.push(lowerCaseCharacters.charAt(this.random(lowerCaseCharacters.length - 1)))
    }

    for (let i = 0; i < this.random(4, 6); i++) {
      passwordArray.push(upperCaseCharacters.charAt(this.random(upperCaseCharacters.length - 1)))
    }

    for (let i = 0; i < this.random(1, 2); i++) {
      passwordArray.push(numberCharacters.charAt(this.random(numberCharacters.length - 1)))
    }

    for (let i = 0; i < this.random(1, 2); i++) {
      passwordArray.push(specialCharacters.charAt(this.random(specialCharacters.length - 1)))
    }

    return passwordArray.sort(() => Math.random() - 0.5).join('')
  }

  validateEmail(email: string) {
    const regExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return regExp.test(email)
  }

  containForbiddenChars(input: string) {
    // eslint-disable-next-line
    const format = /[!@#$%^&*()_+\=\[\]{};':"\\|,<>\/?]+/
    return format.test(input)
  }

  random(a = 1, b = 0) {
    const lower = Math.ceil(Math.min(a, b))
    const upper = Math.floor(Math.max(a, b))
    return Math.floor(lower + Math.random() * (upper - lower + 1))
  }

  isNumber(value: any) {
    return typeof value === 'number'
  }

  formatNumber(value: number, options: FormatOptions = {}) {
    numbro.setLanguage(LANGUAGE_CODE)
    const normalizedValue = options.threshold && value <= options.threshold ? options.threshold : value
    const formattedValue = numbro(normalizedValue).format({
      average: (!!options.shorten && normalizedValue >= 1000) || normalizedValue <= -1000,
      mantissa: options.mantissa || 0,
      forceSign: normalizedValue !== 0 && !!options.sign,
      thousandSeparated: true,
      trimMantissa: true,
      optionalMantissa: true,
    })

    return `${options.threshold && value <= options.threshold ? '< ' : ''}${formattedValue}`
  }

  formatCurrency(value: number, options: FormatOptions = {}) {
    numbro.setLanguage(LANGUAGE_CODE)
    const normalizedValue = options.threshold && value <= options.threshold ? options.threshold : value
    const formattedValue = numbro(normalizedValue).formatCurrency({
      average: (!!options.shorten && normalizedValue >= 1000) || normalizedValue <= -1000,
      mantissa: options.mantissa || 0,
      forceSign: normalizedValue !== 0 && !!options.sign,
      thousandSeparated: true,
      trimMantissa: true,
      optionalMantissa: true,
    })

    return `${options.threshold && value <= options.threshold ? '< ' : ''}${formattedValue}`
  }

  formatPercent = (value: number, options: Omit<Intl.NumberFormatOptions, 'style'> = {}): string => {
    return new Intl.NumberFormat('us', { style: 'percent', ...options }).format(value)
  }

  demographicsIsAvailableForMarket(marketIso: string) {
    return marketIso === 'us'
  }

  getDayDifferenceFromTwoDates(pastDateTimestamp: number, futureDateTimestamp: number) {
    const timeDiff = Math.abs(futureDateTimestamp - pastDateTimestamp)
    const daysDifference = Math.floor(timeDiff / (1000 * 3600 * 24))
    return daysDifference
  }

  motivationsIsAvailableForMarket = (marketIso: string) => {
    return !['jp', 'cn'].includes(marketIso)
  }

  isMotivationAllowedMarkets = (marketIso: string) => {
    return ['us', 'nz', 'au', 'ca'].includes(marketIso)
  }

  chartColorlist: ChartColorList[] = [
    {
      r: 99,
      g: 136,
      b: 180,
    },
    {
      r: 255,
      g: 174,
      b: 52,
    },
    {
      r: 239,
      g: 111,
      b: 106,
    },
    {
      r: 140,
      g: 194,
      b: 202,
    },
    {
      r: 85,
      g: 173,
      b: 137,
    },
    {
      r: 195,
      g: 188,
      b: 63,
    },
    {
      r: 187,
      g: 118,
      b: 147,
    },
    {
      r: 186,
      g: 160,
      b: 148,
    },
    {
      r: 169,
      g: 181,
      b: 174,
    },
    {
      r: 118,
      g: 118,
      b: 118,
    },
  ]
  getChartColorList = () => {
    return this.chartColorlist
  }

  segmentColorArray: ChartColorList[] = [
    { r: 78, g: 172, b: 196 },
    { r: 204, g: 129, b: 69 },
    { r: 176, g: 85, b: 201 },
    { r: 181, g: 60, b: 60 },
    { r: 85, g: 201, b: 112 },
    { r: 185, g: 191, b: 31 },
  ]
  getChartColorListMarketExplorerSegments = () => {
    return this.segmentColorArray
  }
  getRGBChartColorList = () => {
    return this.chartColorlist.map(({ r, g, b }) => `rgb(${r},${g},${b})`)
  }
  shortenNumber = (num: number, forcedThousands: boolean = false, decimalCount: number = 2) => {
    if (!num) return '0'
    let value = '0'
    if (num >= 1000000000 || num <= -1000000000) {
      value = (Math.round(num / 10000000) / 100).toLocaleString('en', { useGrouping: false, minimumFractionDigits: decimalCount }) + 'b'
    } else if (num >= 1000000 || num <= -1000000) {
      value = (Math.round(num / 10000) / 100).toLocaleString('en', { useGrouping: false, minimumFractionDigits: decimalCount }) + 'm'
    } else if (forcedThousands && (num >= 1000 || num <= -1000)) {
      value = (Math.round((num / 1000) * 10) / 10).toLocaleString('en', { useGrouping: false, minimumFractionDigits: decimalCount }) + 'k'
    } else {
      value = num.toLocaleString('en-US')
    }
    return value
  }
  /**
   * getPasswordStrength
   */
  public getPasswordStrength(password: string) {
    const passwordLengthIsCorrect = (length: number) => password.length >= length
    const passwordContainsLowercaseLetter = !!password.match(/[a-z]/)
    const passwordContainsUppercaseLetter = !!password.match(/[A-Z]/)
    const passwordContainsNumber = !!password.match(/[0-9]/)
    const passwordContainsSpecialCharacter = /[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/g.test(password)

    const passwordCheck = [
      passwordContainsLowercaseLetter,
      passwordContainsUppercaseLetter,
      passwordContainsNumber,
      passwordContainsSpecialCharacter,
      passwordLengthIsCorrect(10),
    ]

    let validCount = 0
    passwordCheck.forEach((checkCategory) => {
      if (checkCategory) {
        validCount += 1
      }
    })

    if (!password.length) return ''

    if (!passwordCheck[4]) return 'too-short'
    if (validCount > 1 && validCount < 4) return 'weak'
    if (validCount === 4) return 'moderate'
    if (validCount === 5) return 'strong'
  }

  /**
   * sortVersions sort versions based on semver
   */
  public sortVersions(versions: string[]) {
    return versions
      .map((version) => {
        const [major, minor, patch] = version.split('.')
        const formatted = `${Number(major)}.${Number(minor)}${patch ? '.' + Number(patch) : '.0'}`
        return { formatted, original: version }
      })
      .sort((a, b) => {
        if (!semver.valid(a.formatted) || !semver.valid(b.formatted)) {
          return -1
        }

        return semver.gt(a.formatted, b.formatted) ? 1 : -1
      })
      .map((version) => version.original)
  }

  /**
   * [{
   * formatted : '2.64.0', original : '2.64'
   * }]
   */

  /**
   * oldestReleaseDate to sort release date of games
   */
  public oldestReleaseDate(games: FeatureGame[]) {
    const sortedFeatureGames = [...games]
      .map((game) => getCombinedScreenshots(game))
      .flat()
      .filter((screenshot) => !!screenshot.versionReleaseDate)
      .sort(sortByReleaseDate)

    if (!sortedFeatureGames.length) return

    return new Date(sortedFeatureGames[0].versionReleaseDate || 0)
  }

  public sortedReleaseDate(game: FeatureGame) {
    const sortedFeatureGames = getCombinedScreenshots(game).flat().sort(sortByReleaseDate)

    if (!sortedFeatureGames.length) return
    return new Date(sortedFeatureGames.find((game) => game.versionReleaseDate !== 0)?.versionReleaseDate || 0)
  }

  public orderBy<T>(arr: T[], props: (keyof T)[], orders: ('asc' | 'desc')[]): T[] {
    return arr.sort((a, b) => {
      for (let i = 0; i < props.length; i++) {
        const prop = props[i]
        const order = orders[i] === 'asc' ? 1 : -1

        if (a[prop] < b[prop]) return -1 * order
        if (a[prop] > b[prop]) return 1 * order
      }

      return 0
    })
  }
}

const sortByReleaseDate = (a: Screenshot, b: Screenshot) => {
  const first = a.versionReleaseDate || 0
  const next = b.versionReleaseDate || 0
  return first - next
}

const utilsService = new UtilsService()

export default utilsService
